import { useState, useEffect } from "react";
import { fetchAPI } from "../utils/api";

export const useFetch = (endpoint, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!endpoint) return;

    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await fetchAPI(endpoint);
        setData(result.success ? result.data : result);
      } catch (err) {
        setError(err.message);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [endpoint, ...dependencies]);

  return { data, loading, error };
};
